import hyperdom from 'hyperdom'
import LocalDate from '@booking-services/localDate'
import formats from 'root-packages/dates/formats.js'
import * as gtmDataLayer from '../analytics/gtm/dataLayer.js'

export default class {
  constructor (model) {
    this.model = model
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  partyText () {
    const model = this.model
    const party = model.party()
    const adultSuffix = party.adults === 1 ? 'adult' : 'adults'
    const adults = `${party.adults} ${adultSuffix}`
    let children = ''
    if (party.children) {
      const suffix = party.children === 1 ? 'child' : 'children'
      children = `and ${party.children} ${suffix}`
    }

    return `${adults} ${children}`
  }

  renderPrice (promisedFlight) {
    const model = this.model
    const party = model.quoteCriteria.party
    const partyTotal = party.adults + party.children

    if (model.config.promisedFlights.pricing === 'bundled') {
      return (
        <div class="promised-flights-search-results__price">
          <div class='promised-flights-search-results__price__total u-smaller-text'>Total price</div>
          {model.formatRelativePrice(promisedFlight.price * partyTotal)}
        </div>
      )
    }

    return (
      <div class="promised-flights-search-results__price">
        <div class="u-margin-bottom-small promised-flights-search-results__price-bundling">
          <strong className="u-uppercase u-smaller-text">Flights</strong>
        </div>
        <div class="promised-flights-search-results__price__total">
          <strong>
            {model.formatRelativePrice(promisedFlight.price * partyTotal)}
          </strong>
        </div>
        <div class="u-smaller-text promised-flights-search-results__price__per-person">
          {model.formatRelativePrice(promisedFlight.price)} / person
        </div>
      </div>
    )
  }

  noResults () {
    return <div class="promised-flights-search-results">
      <div class="promised-flights-search__no-results">
        <div class="no-results">
          <p><strong>No matching flights found.</strong></p>
          <p>Please try changing your search criteria for more results.</p>
        </div>
        <div class="back">
          <a onclick={this.showCriteria.bind(this)} href="#/">back to flight search</a>
        </div>
      </div>
    </div>
  }

  renderFlightArrowIcon () {
    const width = 16
    const height = 13

    return (
      <svg class="promised-flight-arrow" width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg" version="1.1">
        <path fill="currentcolor" d="M10,0.8l5.8,5.8L10,12.5l-1.4-1.4l3.6-3.6L0,7.5v-2l11.9,0L8.6,2.2L10,0.8z"/>
      </svg>
    )
  }

  renderFlightSequence (promisedFlight, cabinTypeOption, showBuySection) {
    const model = this.model
    const departureDate = new LocalDate(model.exploreFlights.departureDate)
    const returnDate = new LocalDate(model.exploreFlights.returnDate)

    function airport (code) {
      const airport = model.airports.find(airport => airport.code === code)
      if (airport) {
        return `${airport.city}`
      }
    }

    function legType (legType) {
      const legTypes = {
        outbound: 'Outbound',
        inbound: 'Return',
      }

      return legTypes[legType] || ''
    }

    function showAirfareNotes () {
      return (
        <div class="airfare-notes">
          Includes one piece of checked baggage per guest. Flights may contain connections.
        </div>
      )
    }

    function dateForLegType (type){
      return type === 'outbound' ? departureDate.format(formats.humanShort) : type === 'inbound' ? returnDate.format(formats.humanShort) : ''
    }

    let buySection
    if (showBuySection) {
      buySection = (
        <div class="promised-flights-search-results__buy">
          {this.renderPrice(promisedFlight)}
          <a class="btn-secondary" style='padding: 16px 16px;' onclick={ev => {ev.preventDefault(); model.promisedFlights.select(promisedFlight)}}>
            Add flights
          </a>
          <div className="promised-flights-search-results__cabin">
            {cabinTypeOption.name}
          </div>
        </div>
      )
    }

    return [
      <div class="promised-flights-search-results__summary">
        {promisedFlight.legs.map(leg => {
          return (
            <div class={`promised-flights-search-results__bound promised-flights-search-results__type_${leg.type}`}>
              <div class="promised-flight-legs">
                <div class="promised-flight-legs__type">{legType(leg.type)} flight</div>
                <div class="promised-flight-legs__leg">
                  <div class="promised-flight-legs__date">{dateForLegType(leg.type)}</div>
                  <div class="promised-flight-legs__departure">
                    <div class="promised-flight-legs__airport-code">{leg.depart}</div>
                    <div class="promised-flight-legs__city-country">{airport(leg.depart)}</div>
                  </div>
                  <div class="promised-flight-legs__flight-connector-icon">
                    {this.renderFlightArrowIcon()}
                  </div>
                  <div class="promised-flight-legs__arrival">
                    <div class="promised-flight-legs__airport-code">{leg.arrive}</div>
                    <div class="promised-flight-legs__city-country">{airport(leg.arrive)}</div>
                  </div>
                </div>
              </div>
              {showAirfareNotes()}
            </div>
          )
        })}
      </div>,
      buySection,
    ]
  }

  cabinTypeOption (cabinType) {
    const cabinTypes = {
      economy: {
        name: 'Economy',
        className: 'economy',
      },
      premiumEconomy: {
        name: 'Premium economy',
        className: 'premium-economy',
      },
    }

    return cabinTypes[cabinType] || {name: '', className: 'default'}
  }

  flightSequence (promisedFlight) {
    const cabinTypeOption = this.cabinTypeOption(promisedFlight.cabin)

    return (
      <div class={`promised-flights-search-results__item promised-flights-search-results__item--${cabinTypeOption.className}`}>
        {this.renderFlightSequence(promisedFlight, cabinTypeOption, true)}
      </div>
    )
  }

  selected () {
    const model = this.model
    const selected = model.selected
    const cabinTypeOption = this.cabinTypeOption(selected.cabin)

    function renderSelectedPrice () {
      if (model.config.promisedFlights.pricing !== 'bundled') {
        return (
          <strong class="promised-flights-search-results__price">
            {model.formatPrice(selected.price)}
          </strong>
        )
      }
    }

    function removeFlight (ev) {
      ev.preventDefault()
      model.promisedFlights.remove()
    }

    return (
      <div class="promised-flights-search-results">
        <div class="promised-flights-search-selected">
          <div class='promised-flights-search-selected__text'>
            <h4>Flights added with your trip</h4>
            <p class="promised-flights-search-selected__party-detail">
              <div class="party">for {this.partyText()}</div>
              {renderSelectedPrice()}
            </p>
          </div>
          <button id="remove-selected-promised-flights" className="btn-secondary-outline"
            onclick={removeFlight} href="#">
            Remove flights
          </button>
        </div>
        <div class={`promised-flights-search-results__item promised-flights-search-results__item--${cabinTypeOption.className} -is-selected`}>
          {this.renderFlightSequence(selected, cabinTypeOption, false)}
        </div>
      </div>
    )
  }

  showCriteria (e) {
    e.preventDefault()
    const promisedFlights = this.model.promisedFlights
    promisedFlights.searchMode = 'criteria'
    return false
  }

  render () {
    const model = this.model
    const promisedFlights = model.promisedFlights
    const searchResults = promisedFlights.searchResults

    return (
      <div class="promised-flights-search-results">
        <a class="btn-secondary-outline" onclick={this.showCriteria.bind(this)}>
            Change search
        </a>
        <div class="promised-flights-search-results__sequences">
          {searchResults.map(this.flightSequence.bind(this))}
        </div>
        <div class="message-info">
          <p>
            Contiki Air offers our best available pricing within economy class. To change your cabin class to premium economy or business, or for any other customization needs, please call our reservations team at <strong>{model.config.phone.general}</strong>.
          </p>
        </div>
      </div>
    )
  }
}
